import { useState } from "react";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import ExhibitorLedgerTable from "./ExhibitorLedgerTable";
import type { TExhibitorLedger } from "./type/reportType";

const ExhibitorLedger = () => {
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<TExhibitorLedger[]>({
		endPoint: "/api/admin/reports/exhibitor-ledger",
		queryKeys: ["account-report"],
		params: {
			name: searchParams.name,
			status: searchParams.status,
			dateRange,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				showDateRange
				headerTitle='Exhibitor Ledger List'
				handleSearchFun={(name) =>
					setSearchParams((prev) => ({ ...prev, name }))
				}
				handleDateRange={(date) => {
					setDateRange(date);
				}}
				statusOptions={[
					{ id: "pending", name: "Pending" },
					{ id: "approved", name: "Approved" },
					{ id: "rejected", name: "Rejected" },
				]}
				handleSelectStatus={(status) =>
					setSearchParams((prev) => ({ ...prev, status }))
				}
				helmetTitle='BTTF - Exhibitor Ledger list'
			>
				<ExhibitorLedgerTable
					data={data?.data || []}
					isLoading={isLoading}
				/>
			</CommCard>
		</>
	);
};
export default ExhibitorLedger;
